module.exports = __webpack_public_path__ + "static/media/gebouw.029f5051.svg";